import Loader from "./Loader";

export default function Spinner() {
  return (
    <div className="w-full flex items-center justify-center h-100">
      <Loader />
    </div>
  );
}
